import { createTheme } from '@mui/material/styles';

export const theme = createTheme({
  typography: {
    fontFamily: '"Montserrat", "Roboto", "Helvetica", "Arial", sans-serif',
  },
  components: {
    MuiButton: {
      styleOverrides: {
        contained: {
          background: 'rgb(4, 162, 179) !important',
          border: '1px solid rgb(4, 162, 179) !important',
          boxShadow: '0px 4px 14px 0px rgba(31, 94, 255, 0.1019607843) !important',
          color: '#fff !important',
          fontFamily: '"Montserrat Medium", sans-serif !important',
          fontWeight: 500,
          textTransform: 'none !important',
          '&:hover': {
            background: 'rgb(3, 140, 155) !important',
            border: '1px solid rgb(3, 140, 155) !important',
          }
        },
        outlined: {
          borderColor: 'rgb(4, 162, 179) !important',
          color: 'rgb(4, 162, 179) !important',
          fontFamily: '"Montserrat Medium", sans-serif !important',
          textTransform: 'none !important',
          '&:hover': {
            borderColor: 'rgb(3, 140, 155) !important',
            backgroundColor: 'rgba(4, 162, 179, 0.04) !important',
          }
        },
        text: {
          fontFamily: '"Montserrat Medium", sans-serif !important',
          textTransform: 'none !important',
        }
      }
    },
    MuiAutocomplete: {
      styleOverrides: {
        option: {
          padding: '0px !important',
        },
      },
    },
  },
});